<template>
  <div>
    <HeaderLayout v-if="$route.path != '/login'" />
    <router-view />
    <FooterLayout v-if="$route.path != '/'" />
    <AnnouncementPopup ref="announcementPopup" />
  </div>
</template>
<script>
import HeaderLayout from '@/components/layouts/HeaderLayout.vue'
import FooterLayout from '@/components/layouts/FooterLayout.vue'
import AnnouncementPopup from '@/components/AnnouncementPopup.vue'
export default {
  components: { HeaderLayout, FooterLayout, AnnouncementPopup },
  watch: {
    '$store.state.user.userInfo.email'(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.announcementPopup?.loadAnnouncements()
        })
      }
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap');

#app {
  font-family: 'Nanum Gothic', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  margin-top: 60px;
  /* background-image: url('@/assets/watermark_KAI.png'); */
}
</style>
